import { NgModule, ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { IonicApp, IonicModule, IonicErrorHandler } from 'ionic-angular';
import { HttpClientModule } from '@angular/common/http';
import { MyApp } from './app.component';
import { ComponentsModule } from '../components/components.module';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { IonicStorageModule } from '@ionic/storage';
import { Camera } from '@ionic-native/camera';
import { Device } from '@ionic-native/device';
import {
  LoginPage,
  TabsPage,
  HomePage,
  HomeTCPage,
  HomePCPage,
  AchievementsPage,
  CargadorTcPageModule,
  ResultadoTcPageModule,
  RetoTcPageModule,
  CargadorPcPageModule,
  ResultadoPcPageModule,
  RetoPcPageModule,
  PerfilPageModule,
  BuscarTcPageModule,
  FortalezasDebilidadesPageModule,
  RecuperarContraseniaPageModule,
  LeaderboardPageModule,
  VsPageModule,
  DetalleRondaPageModule,
  HistoricoRetosPageModule,
  NuevaCampaniaPageModule,
  FinCampaniaPageModule,
  BusquedaTesoroPageModule,
  BusquedaTesoroNivelesPageModule,
  BusquedaTesoroInstruccionesPageModule,
  BusquedaTesoroNivelDetallePageModule,
  BusquedaTesoroPreguntaPageModule,
  BusquedaTesoroResultadoRondaPageModule,
  BusquedaTesoroCofrePageModule,
  NotificacionesPageModule,
  MaterialesApoyoPageModule,
  MaterialApoyoDetallePageModule,
  VideoPlayerPageModule,
  ChagePasswordPageModule,
  InfoBotsPageModule,
  ResultadoBotPageModule,
  OnboardingPageModule
} from '@pages';
import { AuthProvider } from '../providers/auth/auth';
import { DesafioPersonalProvider } from '../providers/desafio-personal/desafio-personal';
import { DesafioEquipoProvider } from '../providers/desafio-equipo/desafio-equipo';
import { LocalNotificationProvider } from '@providers/local-notification/local-notification';
import { InterceptorModule } from '../providers/http-interceptor/interceptor.module';
import { LoadingProvider } from '../providers/loading/loading';
// import { OneSignal } from '@ionic-native/onesignal';
// import { OneSignal } from '@ionic-native/onesignal/ngx';
import { PushNotificationProvider } from '../providers/push-notification/push-notification';
import { Ng2GoogleChartsModule } from 'ng2-google-charts';
import { DashboardProvider } from '../providers/dashboard/dashboard';
import { AchievementProvider } from '../providers/achievement/achievement';
import { DirectivesModule } from '../directives/directives.module';
import { IonicImageViewerModule } from 'ionic-img-viewer';
import { PipesModule } from '../pipes/pipes.module';

import { Network } from '@ionic-native/network';
import { DeviceProvider } from '../providers/device/device';
import { SesionProvider } from '../providers/sesion/sesion';
import { CampaignsProvider } from '../providers/campaigns/campaigns';

// Translation
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { LanguageProvider } from '../providers/language/language';

import { Globalization } from '@ionic-native/globalization';

import { CertificacionProvider } from '../providers/certificacion/certificacion';
import { BusquedaTesoroProvider } from '../providers/busqueda-tesoro/busqueda-tesoro';
import { MenuProvider } from '../providers/menu/menu';
import { MaterialesApoyoProvider } from '../providers/materiales-apoyo/materiales-apoyo';

import { ScreenOrientation } from '@ionic-native/screen-orientation';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { FileTransfer } from '@ionic-native/file-transfer';
import { NotificacionesProvider } from '../providers/notificaciones/notificaciones';
import { ColorProvider } from '../providers/color/color';


@NgModule({
  declarations: [
    MyApp,
    HomePage,
    TabsPage,
    LoginPage,
    HomeTCPage,
    HomePCPage,
    AchievementsPage
  ],
  imports: [
    IonicStorageModule.forRoot({
      name: 'game_if_db',
      driverOrder: ['indexeddb', 'sqlite', 'websql']
    }),
    TranslateModule.forRoot({
      loader: {
          provide: TranslateLoader,
          useFactory: (http: HttpClient) => new TranslateHttpLoader(http, './assets/i18n/', '.json'),
          deps: [ HttpClient ]
        }
    }),
    InterceptorModule,
    BrowserModule,
    HttpClientModule,
    IonicModule.forRoot(MyApp, { 
      scrollPadding: false,
      mode: 'md'
    }),
    CargadorTcPageModule,
    ResultadoTcPageModule,
    RetoTcPageModule,
    CargadorPcPageModule,
    ResultadoPcPageModule,
    RetoPcPageModule,
    PerfilPageModule,
    ComponentsModule,
    BuscarTcPageModule,
    Ng2GoogleChartsModule,
    FortalezasDebilidadesPageModule,
    IonicImageViewerModule,
    RecuperarContraseniaPageModule,
    DirectivesModule,
    PipesModule,
    LeaderboardPageModule,
    VsPageModule,
    DetalleRondaPageModule,
    HistoricoRetosPageModule,
    NuevaCampaniaPageModule,
    FinCampaniaPageModule,
    BusquedaTesoroPageModule,
    BusquedaTesoroNivelesPageModule,
    BusquedaTesoroInstruccionesPageModule,
    BusquedaTesoroNivelDetallePageModule,
    BusquedaTesoroPreguntaPageModule,
    BusquedaTesoroResultadoRondaPageModule,
    BusquedaTesoroCofrePageModule,
    NotificacionesPageModule,
    MaterialesApoyoPageModule,
    MaterialApoyoDetallePageModule,
    VideoPlayerPageModule,
    ChagePasswordPageModule,
    InfoBotsPageModule,
    ResultadoBotPageModule,
    OnboardingPageModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    HomePage,
    TabsPage,
    LoginPage,
    HomeTCPage,
    HomePCPage,
    AchievementsPage
  ],
  providers: [
    StatusBar,
    SplashScreen,
    Camera,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    AuthProvider,
    DesafioPersonalProvider,
    DesafioEquipoProvider,
    LocalNotificationProvider,
    LoadingProvider,
    PushNotificationProvider,
    DashboardProvider,
    AchievementProvider,
    Network,
    Device,
    DeviceProvider,
    SesionProvider,
    CampaignsProvider,
    Globalization,
    LanguageProvider,
    CertificacionProvider,
    BusquedaTesoroProvider,
    MenuProvider,
    MaterialesApoyoProvider,
    ScreenOrientation,
    InAppBrowser,
    FileTransfer,
    NotificacionesProvider,
    ColorProvider
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts